let header = document.getElementsByClassName("header-wrapper")[0];
let scrollContainer = document.getElementsByClassName("scroll-container")[0];
let ticking = false;

function hideHeader(scrollPos) {
    // basically 40vh (works better with mobile)
    half_max_height = window.innerHeight * 0.4;

    // If inside the first Slide, show it, but reduce opacity by scrolling down
    if (scrollPos < half_max_height) { 
        opacity = 1 - scrollPos / half_max_height;
        header.style.opacity = opacity;

        if (opacity < 0.1) {
            header.style.display = "none";
        }

        if (opacity > 0.1) {
            header.style.display = "block";
        }
    } else {
        header.style.display = "none"
    }
}

// TODO: Perhaps remove this ticking thing to remove bugs (Fast Scroll does not make this disappear)
scrollContainer.addEventListener("scroll", (e) => {
    if (!ticking) {
        window.requestAnimationFrame(() => {
            hideHeader(e.target.scrollTop);
            ticking = false;
        });
        ticking = true;
    }
});
